import React from 'react';
import MusicRecommend from '../components/MusicRecommend';

const MusicRecommendContainer = () => {
  return <MusicRecommend />;
};

export default MusicRecommendContainer;
